var _this = this;

// from underscore
var _now = function _now() {
  return new Date().getTime();
};
/**
 * 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
 * @memberof module:debounce
 * @param  {function} func        传入函数
 * @param  {number}   wait        表示时间窗口的间隔
 * @param  {boolean}  immediate   设置为 ture 时，调用触发于开始边界而不是结束边界
 * @return {function}             返回客户调用函数
 */


var debounce = function debounce(func, wait, immediate) {
  var timeout;
  var args;
  var context;
  var timestamp;
  var result;

  var later = function later() {
    // 据上一次触发时间间隔
    var last = _now() - timestamp; // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait

    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null; // 如果设定为 immediate === true，因为开始边界已经调用过了此处无需调用

      if (!immediate) {
        result = func.apply(context, args);

        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function () {
    context = _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    args = _args;
    timestamp = _now();
    var callNow = immediate && !timeout; // 如果延时不存在，重新设定延时

    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
};
/* eslint-disable import/prefer-default-export */


export { debounce };